// How often the Cockpit re-checks a permission answer that came back degraded,
// in its own module with no imports so Node's test runner can pin the schedule.
//
// WHY THIS EXISTS
//
// 30 August 2026. Both banners were on screen, "We could not verify your access
// just now" and "We could not verify your permissions just now", with "0
// vehicles" and "Login not linked to a manager" under them, on an account that
// is an admin and is linked. The API was answering correctly at that moment: 46
// of 48 calls clean, and the two that were not were a dropped connection.
//
// So the banner was not describing the present. It was describing one failed
// reply, and then staying. getCapabilities deliberately sits out the refresh
// wave that every write triggers, for a good reason written down in
// useBackend.ts (who can do what does not change because somebody ticked a
// task), and the consequence nobody followed through on is that once it is
// wrong it stays wrong until the operator comes back to the window or presses
// Retry. Reloading the page was the only reliable cure, which is exactly the
// complaint.
//
// A degraded answer is retryable by its own definition. So retry it, twice,
// backing off, and then stop and leave the banner and its Retry button to the
// operator. Two attempts because a transport blip clears in milliseconds and a
// real outage will not clear at all, and a page that re-asks forever during an
// outage adds load at the worst possible moment.
export const DEGRADED_RETRY_DELAYS_MS = [1200, 4000] as const

/** The delay before attempt `attempt`, or null when the schedule is spent. */
export function nextDegradedDelay(attempt: number): number | null {
  return attempt >= 0 && attempt < DEGRADED_RETRY_DELAYS_MS.length
    ? DEGRADED_RETRY_DELAYS_MS[attempt]
    : null
}
